import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/sections/HeroSection';
import { PainSection } from './components/sections/PainSection';
import { DreamSection } from './components/sections/DreamSection';
import { MechanismSection } from './components/sections/MechanismSection';
import { GallerySection } from './components/sections/GallerySection';
import { InstructorSection } from './components/sections/InstructorSection';
import { CurriculumSection } from './components/sections/CurriculumSection';
import { BonusSection } from './components/sections/BonusSection';
import { OutcomesSection } from './components/sections/OutcomesSection';
import { GuaranteeSection } from './components/sections/GuaranteeSection';
import { QualificationSection } from './components/sections/QualificationSection';
import { TestimonialsSection } from './components/sections/TestimonialsSection';
import { FAQSection } from './components/sections/FAQSection';
import { FinalCTASection } from './components/sections/FinalCTASection';
import { StickyBar } from './components/ui/StickyBar';
import { SectionDivider } from './components/ui/SectionDivider';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (!window.fbq) {
      const n: any = window.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    window.fbq('init', '1805115446766680');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-[#FDF8F4]" data-id="element-0">
      {/* Hero Section */}
      <HeroSection data-id="element-1" />

      <SectionDivider variant="flame" data-id="element-2" />

      {/* Pain & Story Section */}
      <PainSection data-id="element-3" />

      <SectionDivider variant="line" data-id="element-4" />

      {/* Dream/Vision Section */}
      <DreamSection data-id="element-5" />

      {/* Gallery Showcase */}
      <GallerySection data-id="element-6" />

      {/* Mechanism Section */}
      <MechanismSection data-id="element-7" />

      <SectionDivider variant="ornament" data-id="element-8" />

      {/* Instructor Section */}
      <InstructorSection data-id="element-9" />

      <SectionDivider variant="flame" data-id="element-10" />

      {/* Curriculum Section */}
      <CurriculumSection data-id="element-11" />

      {/* Bonus Section */}
      <BonusSection data-id="element-12" />

      <SectionDivider variant="line" data-id="element-13" />

      {/* Outcomes Section */}
      <OutcomesSection data-id="element-14" />

      {/* Guarantee Section */}
      <GuaranteeSection data-id="element-15" />

      <SectionDivider variant="ornament" data-id="element-16" />

      {/* Qualification Section */}
      <QualificationSection data-id="element-17" />

      {/* Testimonials Section */}
      <TestimonialsSection data-id="element-18" />

      <SectionDivider variant="flame" data-id="element-19" />

      {/* FAQ Section */}
      <FAQSection data-id="element-20" />

      {/* Final CTA Section */}
      <FinalCTASection data-id="element-21" />

      {/* Sticky CTA Bar */}
      <StickyBar data-id="element-22" />
    </div>;
}